/**
 * Prépare une photo de profil avant l'envoi : recadrée au carré (centre de l'image), réduite à
 * 512 pixels de côté et réenregistrée en JPEG. L'envoi est plus court et l'affichage plus léger ;
 * le serveur reste seul juge du contenu. Si le navigateur ne sait pas lire l'image, le fichier
 * d'origine est envoyé tel quel.
 */
export const PROFILE_PHOTO_SIDE = 512;

export async function squarePhoto(file: File, side = PROFILE_PHOTO_SIDE): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file);
    const crop = Math.min(bitmap.width, bitmap.height);
    const target = Math.min(side, crop);
    const canvas = document.createElement('canvas');
    canvas.width = target;
    canvas.height = target;
    const context = canvas.getContext('2d');
    if (!context || !crop) return file;
    // Fond blanc : une image transparente ne devient pas noire en JPEG.
    context.fillStyle = '#fff';
    context.fillRect(0, 0, target, target);
    context.drawImage(bitmap, (bitmap.width - crop) / 2, (bitmap.height - crop) / 2, crop, crop, 0, 0, target, target);
    bitmap.close?.();
    const blob = await new Promise<Blob | null>((done) => canvas.toBlob(done, 'image/jpeg', 0.88));
    return blob ?? file;
  } catch {
    return file;
  }
}
